<template>
  <div>
    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out duration-300 transition"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition ease-in duration-300"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isOpen"
        class="fixed inset-0 transition-opacity w-full h-full z-999"
      >
        <div class="absolute inset-0 bg-neutral-900 opacity-75" />
      </div>
    </transition>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="ease-in duration-75"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-999"
      >
        <div
          class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transition-all sm:max-w-lg sm:w-full sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div>
            <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-indigo-100">
              <fa
                :icon="icon"
                class="text-indigo-600 text-2xl"
              />
            </div>
            <div class="mt-3 text-center sm:mt-5">
              <h3
                v-if="heading"
                id="modal-headline"
                class="text-lg leading-6 font-medium text-neutral-900"
              >
                {{ heading }}
              </h3>
              <div class="mt-2">
                <p class="text-sm leading-5 text-neutral-500">
                  {{ body }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
            <span
              class="flex w-full rounded-md shadow-sm"
              :class="{ 'sm:col-start-2': isCancelOpen, 'sm:col-span-2': !isCancelOpen }"
            >
              <vetster-button-legacy
                variant="primary"
                type="button"
                class="cursor-pointer inline-flex justify-center w-full"
                data-testid="confirm-window-submit"
                @click="agree"
              >
                {{ confirmText }}
              </vetster-button-legacy>
            </span>
            <span
              v-if="isCancelOpen"
              class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
            >
              <vetster-button-legacy
                variant="outline"
                type="button"
                class="cursor-pointer inline-flex justify-center w-full"
                @click="cancel"
              >
                {{ cancelText }}
              </vetster-button-legacy>
            </span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Vue from 'vue';

import setGlobalProperty from '@/helpers/setGlobalProperty';
import CloseOnEscape from '@/mixins/CloseOnEscape';

library.add(faCheck);

export default {
  name: 'VetsterConfirm',

  mixins: [CloseOnEscape],

  data() {
    return {
      body: '',
      heading: '',
      confirmText: this.$t('app.confirm'),
      cancelText: this.$t('app.cancel'),
      icon: ['fal', 'check'],
      isOpen: false,
      isCancelOpen: true,
      resolve: () => {},
      reject: () => {},
    };
  },

  created() {
    setGlobalProperty(Vue, '$confirm', this.open);
  },

  methods: {
    open(body, heading, options) {
      this.closeOnEscape(this.cancel);

      this.body = body;
      this.heading = heading;
      this.confirmText = 'Confirm';
      this.cancelText = 'Cancel';
      this.icon = ['fal', 'check'];

      if (options) {
        if (options.confirmText) {
          this.confirmText = options.confirmText;
        }

        if (options.confirmText) {
          this.cancelText = options.cancelText;
        }

        if (options.icon) {
          this.icon = options.icon;
        }

        if (options.isCancelOpen != null) {
          this.isCancelOpen = options.isCancelOpen;
        }
      }

      this.isOpen = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.destroyCloseOnEscape();
      this.resolve(true);
      this.isOpen = false;
    },

    cancel() {
      this.destroyCloseOnEscape();
      this.resolve(false);
      this.isOpen = false;
    },
  },
};
</script>
